import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'operationLogRecord', name: 'operationLogRecord', meta: { name: '操作日志' }, component: () => import('../views/manager/operationLogRecord') },
      { path: 'user', name: 'User', meta: { name: '用户信息' }, component: () => import('../views/manager/Employee') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'employeePerson', name: 'EmployeePerson', meta: { name: '个人信息' }, component: () => import('../views/manager/EmployeePerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },

      { path: 'platformPaper', name: 'platformPaper', meta: { name: '查重平台（论文）维护' }, component: () => import('../views/manager/platformPaper') },
      { path: 'platformRewrite', name: 'platformRewrite', meta: { name: '降重平台（降重）维护' }, component: () => import('../views/manager/platformRewrite') },
      { path: 'frontendFramework', name: 'frontendFramework', meta: { name: '前端框架维护' }, component: () => import('../views/manager/frontendFramework') },
      { path: 'backendFramework', name: 'backendFramework', meta: { name: '后端框架维护' }, component: () => import('../views/manager/backendFramework') },
      { path: 'languageType', name: 'languageType', meta: { name: '语言类型维护' }, component: () => import('../views/manager/languageType') },
      { path: 'numberManage', name: 'numberManage', meta: { name: '字数维护' }, component: () => import('../views/manager/numberManage') },
      { path: 'specialType', name: 'specialType', meta: { name: '特殊类型维护' }, component: () => import('../views/manager/specialType') },
      { path: 'paperLimit', name: 'paperLimit', meta: { name: '论文额度配置' }, component: () => import('../views/manager/paperLimit') },

      { path: 'paperPriceConfig', name: 'paperPriceConfig', meta: { name: '论文价格配置' }, component: () => import('../views/manager/paperPriceConfig') },
      { path: 'proposalPriceConfig', name: 'proposalPriceConfig', meta: { name: '开题价格配置' }, component: () => import('../views/manager/proposalPriceConfig') },
      { path: 'rewritePriceConfig', name: 'rewritePriceConfig', meta: { name: '降重价格配置' }, component: () => import('../views/manager/rewritePriceConfig') },
      { path: 'paperOrder', name: 'paperOrder', meta: { name: '论文订单管理' }, component: () => import('../views/manager/paperOrder') },
      { path: 'proposalOrder', name: 'proposalOrder', meta: { name: '开题订单管理' }, component: () => import('../views/manager/proposalOrder') },
      { path: 'rewriteOrder', name: 'rewriteOrder', meta: { name: '降重订单管理' }, component: () => import('../views/manager/rewriteOrder') },
      { path: 'abandonedOrder', name: 'abandonedOrder', meta: { name: '废单管理' }, component: () => import('../views/manager/abandonedOrder') },
      { path: 'settlement', name: 'settlement', meta: { name: '结算管理' }, component: () => import('../views/manager/settlement') },
      { path: 'settlementInfo', name: 'settlementInfo', meta: { name: '结算管理' }, component: () => import('../views/manager/settlementInfo') },

      
      { path: 'myPaperOrder', name: 'myPaperOrder', meta: { name: '论文订单' }, component: () => import('../views/manager/myPaperOrder') },
      { path: 'myProposalOrder', name: 'myProposalOrder', meta: { name: '开题订单' }, component: () => import('../views/manager/myProposalOrder') },
      { path: 'myRewriteOrder', name: 'myRewriteOrder', meta: { name: '降重订单' }, component: () => import('../views/manager/myRewriteOrder') },
      { path: 'myAbandonedOrder', name: 'myAbandonedOrder', meta: { name: '废单查看' }, component: () => import('../views/manager/myAbandonedOrder') },
      { path: 'mySettlement', name: 'mySettlement', meta: { name: '结算管理' }, component: () => import('../views/manager/mySettlement') },
      { path: 'addPaperOrder', name: 'addPaperOrder', meta: { name: '创建论文订单' }, component: () => import('../views/manager/addPaperOrder') },
      { path: 'addRewriteOrder', name: 'addRewriteOrder', meta: { name: '创建降重订单' }, component: () => import('../views/manager/addRewriteOrder') },
      { path: 'addProposalOrder', name: 'addProposalOrder', meta: { name: '创建开题订单' }, component: () => import('../views/manager/addProposalOrder') },
      { path: 'editPaperOrder', name: 'editPaperOrder', meta: { name: '修改论文订单' }, component: () => import('../views/manager/editPaperOrder') },
      { path: 'editProposalOrder', name: 'editProposalOrder', meta: { name: '修改开题订单' }, component: () => import('../views/manager/editProposalOrder') },
      { path: 'editRewriteOrder', name: 'editRewriteOrder', meta: { name: '修降重题订单' }, component: () => import('../views/manager/editRewriteOrder') },

    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 注：不需要前台的项目，可以注释掉该路由守卫
// 路由守卫
// router.beforeEach((to ,from, next) => {
//   let user = JSON.parse(localStorage.getItem("xm-user") || '{}');
//   if (to.path === '/') {
//     if (user.role) {
//       if (user.role === 'USER') {
//         next('/front/home')
//       } else {
//         next('/home')
//       }
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

export default router
